import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { useLoadCustomer } from '../hooks/useLoadCustomer'

type TContextValue = ReturnType<typeof useLoadCustomer>['customer']

const [
  Provider, //
  useCustomerCtx,
] = createContext<TContextValue>(`Customer`)

type TProps = RequiredChildren & {
  value: TContextValue
}

/**
 * Loads and provides customer information (name, phone number, email, addresses etc.).
 *
 * If customer account feature is disabled, provides `null` as a value.
 */
export const BaseCustomerProvider: React.FC<TProps> = ({ value, children }) => {
  return <Provider value={value}>{children}</Provider>
}

export { useCustomerCtx }
